import { selectGates } from '../../reducers/Portal';
export default function (state) {
  const isSpeculationGate = selectGates(state).includes('Speculation');
  if (isSpeculationGate !== true || !HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) {
    return;
  }
  const {
    byId
  } = state.navItems;
  const appUrls = Object.values(byId).filter(navItem => navItem.path !== undefined).map(navItem => navItem.path);
  const specScript = document.createElement('script');
  specScript.type = 'speculationrules';
  const specRules = {
    prerender: [{
      eagerness: 'moderate',
      urls: appUrls
    }, {
      where: {
        selector_matches: "a[href*='contacts/'][href*='/record/']"
      },
      eagerness: 'moderate'
    }]
  };
  specScript.textContent = JSON.stringify(specRules);
  document.body.append(specScript);
}